import { createSelector } from 'reselect';

// Config
import { getPaymentThreeDSMethodInfoSelector } from '@redux/reducers/payment/paymentSelector';

const threeDSecureMethodState = createSelector([getPaymentThreeDSMethodInfoSelector], (threeDSMethodInfo) => ({
  action: threeDSMethodInfo?.threeDSMethodUrl,
  id: threeDSMethodInfo?.threeDSMethodFormId,
  inputData: threeDSMethodInfo?.threeDSMethodDataFormData,
}));

export default threeDSecureMethodState;
